import { render } from "./ServiceAccountsPage.vue?vue&type=template&id=5865928e"
import script from "./ServiceAccountsPage.vue?vue&type=script&lang=js"
export * from "./ServiceAccountsPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__